import { to24HrTime } from 'lib/utils/time'
import { LdJsonHotel } from 'src/types/head'
import { PropertyAPIResponse } from 'src/types/property'

export const generateRichHeadHotel = (property: PropertyAPIResponse, url: string) => {
  if (!property || !url) {
    return {}
  }

  const {
    name,
    photo,
    description,
    conditions,
    address,
    city,
    postalCode,
    country,
    stars,
    ratings,
    facilities,
    latitude,
    longitude,
  } = property
  const ldJSON: LdJsonHotel = {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    logo: 'https://static.stayforlong.com/web/images/sfl-logo_x2.png',
    url,
  }
  if (name) ldJSON.name = name
  if (photo) ldJSON.image = photo
  if (description && description?.generic) ldJSON.description = description.generic
  if (conditions) {
    if (conditions?.checkin?.beginTime && conditions?.checkin?.beginTime !== '') {
      ldJSON.checkinTime = to24HrTime(conditions.checkin.beginTime)
    }
    if (conditions?.checkout?.time && conditions?.checkout?.time !== '') {
      ldJSON.checkoutTime = to24HrTime(conditions.checkout.time)
    }
  }
  if (latitude && longitude) {
    ldJSON.geo = {
      '@type': 'GeoCoordinates',
      latitude,
      longitude,
    }
  }
  if (address || city || postalCode || country) {
    ldJSON.address = {
      '@type': 'PostalAddress',
    }
    if (address) ldJSON.address.streetAddress = address
    if (city) ldJSON.address.addressLocality = city
    if (postalCode) ldJSON.address.postalCode = postalCode
    if (country) ldJSON.address.addressCountry = country
  }
  if (stars) {
    ldJSON.starRating = {
      '@type': 'https://schema.org/Rating',
      ratingValue: stars,
    }
  }
  if (ratings && ratings.score && ratings.count) {
    ldJSON.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: ratings.score,
      reviewCount: ratings.count,
      bestRating: 10,
    }
  }
  if (facilities) {
    ldJSON.amenityFeature = facilities.map(facility => ({
      '@type': 'LocationFeatureSpecification',
      name: facility.name,
      value: 'True',
    }))
  }
  return ldJSON
}
